/**
 * Contesto del tema, separato da `ProviderTema.tsx`: un file di componenti
 * che esporta anche un hook perde il ricaricamento a caldo di Vite.
 */

import { createContext, useContext } from 'react';
import type { IdTema, Modo } from './catalogo.js';

export const Tema = createContext<{
  tema: IdTema;
  modo: Modo;
  impostaTema: (valore: string) => void;
  impostaModo: (valore: string) => void;
} | null>(null);

export function useTema() {
  const ctx = useContext(Tema);
  if (!ctx) throw new Error('useTema richiede ProviderTema');
  return ctx;
}
